import { render, staticRenderFns } from "./PolicyDetail.vue?vue&type=template&id=d8cbeb1a&scoped=true&"
import script from "./PolicyDetail.vue?vue&type=script&lang=js&"
export * from "./PolicyDetail.vue?vue&type=script&lang=js&"
import style0 from "./PolicyDetail.vue?vue&type=style&index=0&id=d8cbeb1a&prod&lang=css&"
import style1 from "./PolicyDetail.vue?vue&type=style&index=1&id=d8cbeb1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8cbeb1a",
  null
  
)

export default component.exports